import React, { useState } from 'react';
import { translate } from '../../Services/translation';

const CustomVariantCalculator = ({
  maxWidth,
  width,
  setWidth,
  length,
  setLength,
  onCalculateClick,
  configuratorType,
  panelOptions,
  currencySymbol,
  onOptionChanged,
  selectedOptions,
  isFixedWidth,
}) => {
  const min = 0;
  const max = parseInt(maxWidth);
  const [warning, setWarning] = useState('');
  const PER_PIECE_UNIT = 'st';
  const handleMinMaxValue = (value) => {
    setWarning('');
    if (value <= 0) {
      if (value != '') {
        setWarning(translate('calculator.width-less-than-0'));
      }
      setWidth('');
    } else {
      if (value > maxWidth) {
        setWarning(translate('calculator.width-to-wide'));
      }
      const newValue = Math.max(min, Math.min(max, Number(value)));
      setWidth(newValue);
    }
  };
  return (
    <form>
      <div className="custom-variant__size-picker">
        <div className="styled-text-input">
          <input
            value={width}
            onChange={(e) => setWidth(e.target.value)}
            onBlur={(e) => handleMinMaxValue(parseInt(e.target.value))}
            onBeforeInput={(e) => parseInt(e.target.value)}
            placeholder=" "
            type="number"
            min="0"
            max={maxWidth}
            disabled={isFixedWidth}
          />
          <label>{translate('calculator.width-placeholder')}</label>
          {warning && (
            <div className="text-medium color-error-700">{warning}</div>
          )}
        </div>
        <div className="styled-text-input">
          <input
            value={length}
            onBlur={(e) => setLength(e.target.value > 0 ? e.target.value : 0)}
            onChange={(e) => setLength(e.target.value)}
            placeholder=" "
            type="number"
          />
          <label>{translate('calculator.length-placeholder')}</label>
        </div>
      </div>
      {panelOptions?.length > 0 &&
        panelOptions.map((option) => (
          <div key={option.articleId} className="styled-checkbox-input">
            <input
              id={option.articleId + configuratorType}
              className="checkbox"
              type="checkbox"
              onChange={(e) =>
                onOptionChanged(option.articleId, e.target.checked)
              }
              checked={selectedOptions.indexOf(option.articleId) > -1}
            />
            <label htmlFor={option.articleId + configuratorType}>
              <div>
                {option.name} (
                {option.campaignPrice ? (
                  <>
                    <span className="text-linethrough">{option.price}</span>{' '}
                    <span className="color-error-700">
                      {option.campaignPrice}
                    </span>
                  </>
                ) : (
                  option.price
                )}
                {option.unit != PER_PIECE_UNIT &&
                  translate(`configurator.${option.unit}`)}
                )
              </div>
            </label>
          </div>
        ))}
      <button
        onClick={onCalculateClick}
        className="btn btn--secondary"
        type="button"
      >
        {translate('calculator.calculate')}
      </button>
    </form>
  );
};
export default CustomVariantCalculator;
